// DriverDropdown.jsx
import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress, Typography } from "@mui/material";
import axios from "axios";

const DriverDropdown = ({ driverId, clientId, onDriverChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clientId) return;
    setLoading(true);
    axios
  .get(`/api/employees?client_id=${clientId}`)
  .then((res) => {
    // Case-insensitive, trim extra spaces
    const drivers = res.data.filter(
      (emp) => (emp.employeedrivertype || "").trim().toLowerCase() === "driver"
    );

    console.log("API rows:", res.data.length);      // total from DB
    console.log("Filtered drivers:", drivers.length); // after filter
    console.log("Drivers data:", drivers);

    setOptions(drivers);
    setLoading(false);
  })
  .catch(() => setLoading(false));
  }, [clientId]);

//   const selectedDriver = options.find((o) => o.employeeid === driverId) || null;
  const selectedDriver = options.find(o => o.employeeid === driverId) || null;
// Log to debug current values before rendering
  console.log("driverId:", driverId);
  console.log("options:", options);
  console.log("selectedDriver:", selectedDriver)

  return (
<Autocomplete
  freeSolo
  options={options}
  loading={loading}
  getOptionLabel={(option) => {
  if (typeof option === "string") return option;
  return (
    `${option.employeefirstname || ""} ${option.employeelastname || ""}`.trim() ||
    option.employeemobile ||
    "Unnamed Driver"
  );
}}

  value={selectedDriver}
  isOptionEqualToValue={(option, value) => option.employeeid === value.employeeid} // 👈 FIX
  onChange={(event, newValue) => {
    if (newValue && typeof newValue !== "string") {
      onDriverChange({
        driver_id: newValue.employeeid,
        driver_name: `${newValue.employeefirstname} ${newValue.employeelastname}`,
        driver_mobile: newValue.employeemobile,
      });
    } else {
      onDriverChange({ driver_id: "", driver_name: "", driver_mobile: "" });
    }
  }}
  renderOption={(props, option) => (
    <li {...props} key={option.employeeid} style={{ display: "block" }}>
      <Typography component="div" variant="body2" fontWeight="normal">
        {option.employeefirstname} {option.employeelastname}
      </Typography>
      {option.employeemobile && (
        <Typography
          component="div"
          variant="caption"
          sx={{ fontStyle: "italic", color: "text.secondary" }}
        >
          {option.employeemobile}
        </Typography>
      )}
    </li>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Driver Name"
      size="small"
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {loading ? <CircularProgress color="inherit" size={18} /> : null}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
      sx={{ flexGrow: 1, minWidth: 200 }}
    />
  )}
/>
  );
};

export default DriverDropdown;
